var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.overlay ? 'v-overlay' : 'div',{tag:"component"},[_c('div',{staticClass:"d-flex flex-column justify-center align-center"},[_c('v-progress-circular',{attrs:{"size":_vm.size,"width":_vm.width,"color":_vm.color,"indeterminate":""}}),(_vm.loadingText)?_c('div',{staticClass:"mt-5"},[_vm._v(_vm._s(_vm.loadingText))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }